<template>
  <Popover ref="orderPopover" placement="right" :showHeader="true" :headerTitle="orderTitle">
    <div class="schedule-order-popover-content">
      <Spinner v-if="loading" />
      <div v-if="orderData.id" class="schedule-order-details">
        <h3>Details</h3>
        <div class="row">
          <div class="col-3 station-popover-item-title">Order</div>
          <div class="col-3 station-popover-item-value">#{{orderData.sequenceNumber | formatHyphenEmptyValue}}</div>
          <div class="col-3 station-popover-item-title">Order Due</div>
          <div class="col-3 station-popover-item-value">{{orderData.dateCurrentlyDue | formatDate}}</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Order Status</div>
          <div class="col-3 station-popover-item-value">
            <LabelOrderStatusBadge :status="orderData.status" />
          </div>
          <div class="col-3 station-popover-item-title">Customer</div>
          <div class="col-3 station-popover-item-value">{{orderData.contact.name | formatHyphenEmptyValue}}</div>
          
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Despatch Type</div>
          <div class="col-3 station-popover-item-value">{{orderData.despatchType | formatLookupName(DespatchTypeLookup)}}</div>
          <div class="col-3 station-popover-item-title">Customer Ref</div>
          <div class="col-3 station-popover-item-value">{{orderData.customerRef | formatHyphenEmptyValue}}</div>
        </div>
        <div class="row">
          <div class="col-3 station-popover-item-title">Order Notes</div>
          <div class="col-9 station-popover-item-value">{{orderData.notes | formatHyphenEmptyValue}}</div>
        </div>

        <template v-if="isOrderNCR">
          <div class="row mt-2">
            <div class="col-12">
              <h3 class="text-danger">NCR</h3>
            </div>
          </div>
        </template>

        <div class="row mt-3">
          <div class="col-12">
            <FormHorizontalRule />
            <StationControlPanelButton class="btn-primary" sizeClass="wide-lg" iconStyle="fal" icon="fa-shopping-cart" @click="orderClicked">Order</StationControlPanelButton>
            <StationControlPanelButton class="btn-primary" sizeClass="wide-lg" iconStyle="fal" icon="fa-info-circle" @click="orderItemsClicked">Order Items</StationControlPanelButton>
            <StationControlPanelButton class="btn-primary" sizeClass="wide-lg" iconStyle="fal" icon="fa-book" @click="orderDocumentsClicked">Documents</StationControlPanelButton>
          </div>
        </div>
      </div>
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>
    </div>
  </Popover>
</template>

<style lang="scss" scoped>
$options-height: 60px;

.schedule-order-popover-content {
  min-width: 550px;
  min-height: 200px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.schedule-order-details {
  flex: 1;
}

</style>

<script>
import Popover from '@/components/popover'
import StationControlPanelButton from '@/apps/glass-production-station/src/components/buttons/stationControlPanelButton'
import StationProgressTrackerItem from '@/apps/glass-production-station/src/components/schedule/stationProgressTrackerItem'
import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'

import { ProductionPanelStatusTypes, ProductionPanelStageTaskStatusTypes, DespatchTypeLookup, OrderStatusTypeLookup, OrderTypes } from '@/store/types'

export default {
  name: 'ScheduleOrderPopover',
  components: {
    Popover,
    StationProgressTrackerItem,
    StationControlPanelButton,
    LabelOrderStatusBadge
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      orderId: null,
      orderData: {}
    }
  },
  computed: {
    orderTitle() {
      if(this.loading)
        return 'Loading Order...'
      if(this.loadingError)
        return 'Error loading order'

      return `Order ${this.orderData.sequenceNumber}`
    },
    isOrderNCR() {
      return this.orderData.type == OrderTypes.nonChargeableRework
    },
  },
  created() {
    this.ProductionPanelStatusTypes = ProductionPanelStatusTypes
    this.ProductionPanelStageTaskStatusTypes = ProductionPanelStageTaskStatusTypes
    this.DespatchTypeLookup = DespatchTypeLookup
    this.OrderStatusTypeLookup = OrderStatusTypeLookup
  },
  methods: {
    displayFromElement(element, orderInfo) {
      this.$refs.orderPopover.displayFromElement(element)

      // Reset
      this.orderData = {}
      this.orderId = orderInfo.id

      this.requestData()
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.ordersService.getOrder(this.orderId)
      .then(response => {
        this.orderData = response.data

        // Update popover to adjust for content
        this.$nextTick(() => {
          this.$refs.orderPopover.updatePopper()
        })
      })
      .catch(err => {
        this.loadingError = 'Error loading order data'
      })
      .finally(() => {
        this.loading = false
      })
    },

    orderClicked() {
      this.$refs.orderPopover.hidePopover()
      this.$emit('orderClick', this.orderData)
    },
    orderItemsClicked() {
      this.$refs.orderPopover.hidePopover()
      this.$emit('orderItemsClick', this.orderData)
    },
    orderDocumentsClicked() {
      this.$refs.orderPopover.hidePopover()
      this.$emit('orderDocumentsClick', this.orderData)
    },
  }
}
</script>